// <- TaskManagment.js
import React, { useState, Fragment,useEffect  } from "react";
import { Button, ListGroup, ListGroupItem, Label, Input, Col,
  Row, 
  Table} from "reactstrap";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";
import TableWithSortPagtnAndCheckBox from "../../common/TableWithSortPagtnAndCheckBox";
import ProcessLeaves from "./ProcessLeaves";
import DropDownActions from "../../common/DropDownActions";
import moment from 'moment';
import ReactModal from 'react-modal';
import api from "../../../apis/api";
import Calendar from "react-calendar";
import { red } from "@material-ui/core/colors";
import "../../../style/processleave.css";
import SelectBoxSearch from "../../common/SelectBoxSearch";
import Notifications from "../../../components/common/Notifications";
const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let maxwidth="80vw";
const ListProcessLeaves = React.memo(
  ({
    handleAddEditTaskForm,
    handleSelectedTask,
    handleOpenCalendar,
    handleDelTask,
    empTask,
    taskProjectInfo,
    handleToggleAllTaskCalendar,
    getAllTaskOfEmployee,
    handleUnlockRequestForm,
    handledelAppliedLeaves,
    handelFromDate,
    handelToDate,
    myleavelist,
    handlerecholidayCalendarArray,
    handleleavestatus,
    employeelist,
    loadtask,
    selectedEmployeeId,
    fromDate,
    toDate,
    reloaddata
  }) => {
    const [thead] = useState([
      "Id",
      "Name",
      "Type",
      "Applied",
      "DateFrom",
      "DateTo",
      "Days",
      "Status",
      "ApprovedDate",
      "RejectedDate",
      "Action",

    ]);
    const [trow, setTrow] = useState([]);
    const [activeTask, setActiveTask] = useState(0);
    const [leavelist,setleavelist]=useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [leaverequestDetails, setLeaverequestDetails] = useState([]);
    const [myleavedetailedlist,setmyleavelist]=useState([]);
    const [myappliedleavelist,setmyappliedleavelist]=useState([]);
    const [dateArray,setDateArray]=useState([]);
    const [comment,setcomment]=useState("");
    const [calenderDate] = useState(new Date());
    const [action ,setaction] =useState("");
    const [islistview,setislistview] =useState(true);
    const [isDetailedview,setdetailedview] =useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [selectedEmployeesString, setSelectedEmployeesString] = useState([]);
    const [statusFilter, setStatusFilter] = useState("Pending");
    const [error, setError] = useState(null);
const [loaded, setLoaded] = useState(false);
  const [isOpenForm, setIsOpenForm] = useState(false);
  const DarkBackground = styled.div`
display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
${(props) =>
  props.disappear &&
  css`
    display: block; /* show */
  `}
`;

    const buttonStyles = {
      position: "absolute",
      top: "10px",
      right: "10px"
    };
    let holidaylist=[];
    handlerecholidayCalendarArray.map(function (hol){
    holidaylist.push(moment(hol.holidayDate).format('DD-MM-YYYY'));
  });

  let leavestatuslist=[];
  handleleavestatus.map(function (hol){
    leavestatuslist.push({value :hol.leaveStatusId,label :hol.status});
});
    useEffect(() => {
      setleavelist(empTask);

    },[empTask])
    const handleOnclickSelectedTask = React.useCallback(
      (task, i) => {
        setActiveTask(i);
        handleSelectedTask(task);
      },
      [handleSelectedTask]
    );

  //  const handledelAppliedleave =React.useCallback((leave) =>{
  //   delAppliedLeaves(leave);
  //  },[delAppliedLeaves])

    const DelTask=React.useCallback(
      (delId)=>{
      handleDelTask(delId);
    },[empTask]);
    const getDates = (arrlist) => {
      const dates = [];
      arrlist.forEach(element => {
        if (element.fromDate && element.toDate) {
          const start = new Date(element.fromDate);
          const end = new Date(element.toDate);
          const days = Math.floor((end - start) / (1000 * 60 * 60 * 24));
          
          for (let i = 0; i <= days; i++) {
              const currentDate = new Date(start.getTime() + i * 24 * 60 * 60 * 1000);
              dates.push(moment(currentDate).format("DD-MM-YYYY"));
          }
        
      }
      });
      setDateArray(dates);
  };
const handleDetails=React.useCallback((leaverequestId,employeeId)=>{
  setIsOpen(true);
  const fetchApi = async () => {
    let arr=[];
    let arr1=[];
    let arr2=[];
    await api
    .dbLeaveTypes()
    .GetLeaveRequestById(parseInt(leaverequestId))
    .then((res) =>setLeaverequestDetails(res.data));
    await api
    .dbLeaveTypes()
    .GetLeaveTypesByEmpId(parseInt(employeeId))
    .then((res) =>arr.push(res.data));
    
    await api
    .dbLeaveTypes()
    .GetAppliedLeavesByEmpId(parseInt(employeeId))
    .then((res) =>arr2.push(res.data));
  

    await api
    .dbLeaveTypes()
    .GetAppliedLeavesByRequestId(parseInt(leaverequestId))
    .then((res) =>arr1.push(res.data));

    setmyleavelist(arr[0]);
    setmyappliedleavelist(arr1[0]);
    getDates(arr2[0]);
  }
  fetchApi();
  setislistview(false);
  setdetailedview(true);
})

    useEffect(() => {
  let filtered = [...leavelist];

  if (statusFilter !== "All") {
    filtered = filtered.filter(el => el.leaveStatus === statusFilter);
  }

  let sortedTasks = filtered.sort((a, b) => a.leaveTypeId - b.leaveTypeId);

  let trow = sortedTasks.map((el) => ({
    Id: <div style={{ width: "30px" }}>{el.leaveRequestId}</div>,
    Name: <div style={{ width: "100px" }}>{el.employeeName}</div>,
    Type: <div style={{ width: "100px" }}>{el.type}</div>,
    Applied: (
      <div style={{ width: "100px" }}>
        {moment(el.createdDate).format("DD-MM-YYYY")}
      </div>
    ),
    DateFrom: (
      <div style={{ width: "100px" }}>
        {moment(el.fromDate).format("DD-MM-YYYY")}
      </div>
    ),
    DateTo: (
      <div style={{ width: "100px" }}>
        {moment(el.toDate).format("DD-MM-YYYY")}
      </div>
    ),
    Days: <div style={{ width: "50px" }}>{el.noOfDays}</div>,
    Status: <div style={{ width: "60px" }}>{el.leaveStatus}</div>,
    ApprovedDate: (
      <div style={{ width: "110px" }}>
        {el.approvedDate === "0001-01-01T00:00:00"
          ? null
          : moment(el.approvedDate).format("DD-MM-YYYY")}
      </div>
    ),
    RejectedDate: (
      <div style={{ width: "100px" }}>
        {el.rejectedDate === "0001-01-01T00:00:00"
          ? null
          : moment(el.rejectedDate).format("DD-MM-YYYY")}
      </div>
    ),
    Action: (
      <Button
        color=""
        className="btn-admin-settings"
        onClick={() => handleDetails(el.leaveRequestId, el.empId)}
        data-id={el.leaveRequestId}
      >
        Process
      </Button>
    ),
  }));

  setTrow(trow);
}, [leavelist, statusFilter]); // ✅ now reacts to filter & list

    const handlecancelprocess =React.useCallback(() =>{
      setislistview(true);
      setdetailedview(false);
    },[setislistview,setdetailedview])
    const handleSelectAll = (e) => {
      if (e.target.checked) {
        setSelectedRows(empTask.map((row) => row.leaveTypeId));
      } else {
        setSelectedRows([]);
      }
    };
    const onSelectionChange = (selectedIds) => {
        setSelectedEmployees(selectedIds);
      const childrenValues = selectedIds.map(item => item.props.children).join(",");
      setSelectedEmployeesString(childrenValues);
    };
    const handleApproveSelected= React.useCallback(() =>{
setLoaded(true);
        if (selectedEmployeesString.length === 0) {
          alert("No employees selected for approval.");
          return;
        }
  
        const fetchApi = async () => {
               let arr=[];
            
              const res= await api
               .dbCalendarYear()
               .ApproveAllLeaveRequest(selectedEmployeesString,parseInt(1),comment);
               if(res.status == 200)
               {
                setError({ ...error, message: "Leave Approved Successfully..", status: 200 });
                  
                    reloaddata();
                      setTimeout(() => { 
      setLoaded(false);
  }, 3000);
               }
               
             }
             fetchApi();
    },[selectedEmployeesString,selectedEmployeeId,fromDate,toDate,comment,loginUser]);
    return (
      <Fragment>

          <div className="row">

          <div className="col-md-3">
          <Label for="exampleEmail">From Date</Label>
                <Input
                  type="date"
                  value={fromDate}
                  onChange={(e) => handelFromDate(e.target.value)}
                />
          </div>
          <div className="col-md-3">
          <Label for="exampleEmail">To Date</Label>
                <Input
                  type="date"
                  value={toDate}
                   onChange={(e) => handelToDate(e.target.value)}
                />
          </div>

            &nbsp;

          </div>
          <br/>
            <div className="row">

<div className="col-md-6">
  <Label for="exampleEmail">Employee</Label>
            <SelectBoxSearch
            className="form-control" 
  options={[{ value: "all", label: "All" }, ...employeelist]}
  onChange={(e) => {
    if (e.id === "all") {
      loadtask("all"); // handle loading all employees
    } else {
      loadtask(e); // handle individual employee
    }
  }}
  selectedUser={selectedEmployeeId}
  placeholder="Select Employee"
/>
          </div>
 
          <div className="col-md-6">
<Label for="exampleEmail">Status</Label>
  <select
    value={statusFilter}
    className="form-control"  
    onChange={e => setStatusFilter(e.target.value)}
  >
    <option value="All">All</option>
    <option value="Pending">Pending</option>
    <option value="Approved">Approved</option>
    <option value="Rejected">Rejected</option>
  </select>
</div>
</div>
       <br/>
     {islistview == true ? ( <div className="" style={{ maxWidth: maxwidth, overflowY: "auto" }}>
     {selectedEmployeesString !='' ? (<div style={{textAlign: "right", marginBottom: "10px"}}><Button onClick={handleApproveSelected} style={{background:"white"}} className="btn-admin-settings btn btn btn-outline-secondary btn-sm">
              Process Selected
            </Button></div>) : (null)} 
      <TableWithSortPagtnAndCheckBox thead={thead} trow={trow} pageSize={10} onSelectionChange={onSelectionChange}></TableWithSortPagtnAndCheckBox>
    </div>) : null}  
{isDetailedview == true ? ( <ProcessLeaves
leaverequestDetails={leaverequestDetails}
myleavedetailedlist={myleavedetailedlist}
myappliedleavelist={myappliedleavelist}
handlerecholidayCalendarArray={handlerecholidayCalendarArray}
handleleavestatus={handleleavestatus}
empTask={empTask}
handleSelectedTask={handleSelectedTask}
handleDelTask={handleDelTask}
dateArray={dateArray}
handlecancelprocess={handlecancelprocess}
reloaddata={reloaddata}
></ProcessLeaves>) : null}
   
   
   
     <Notifications notifications={error}></Notifications>
     <DarkBackground disappear={loaded}>
    <LoadingOverlay
          active={true}
          spinner={true}
          text="Loading your content..."
        >
        </LoadingOverlay>
    </DarkBackground>
      </Fragment>
    );
  }
);

export default ListProcessLeaves;
